module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALRJREFUeNpi+P//vwEQf/hPPpgAxAwwzAgyjIGBgZ8BAg4CsQMDbhAAxAZADNJzAYj3Q8UXAnECmIVm2wFk27DgA0hqHdD0LgCpYWGgHogH4gNMDNQFDdQ2UB7dy/ZAXAANcGwAJv4BHgloABTL/6npRGp7GcNAQ5CrScSG+LzMSKbD/tPNy6MGkm9gIxA/pIULBcgwQwA9HSIXsCBXPiDRQAVQoQBlf2SgQhUAAyAzDAACDACzG//IrpOccwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/save.png
// module id = 909
// module chunks = 0